/********************************************************************************
Filename: np-compare-row.js
Created: 05 Apr 2021
Author: Ron Robertson
Description: Displays a row with multiple columns. Data will be loaded into each column for comparing
Usage Example:
<np-compare-row>
</np-compare-row>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            #np-compare-row{
                display:flex;
                justify-content:space-between;
                align-items:center;
                border-bottom: 1px solid #b8b7b3;
                padding:25px 0;
            }
            #np-compare-row > *{
                width: calc((var(--col-width) * 2) + var(--gutter-width));
                text-align:center;
                font-family: var(--bodyFontFamily);
                font-size: var(--bodyFontSize);
            }
            #np-compare-row > .label {
                text-align:left;
                font-family: var(--h4FontFamily);
                font-size: var(--h4FontSize);
            }

            .col2,
            .col3,
            .col4{
                display:none;
            }
            /* Medium */
            @media screen and (min-width: 768px) and (max-width:959px) {
                .col3{
                    display:block;
                }
                #np-compare-row > *{
                    width: calc((var(--col-width) * 3) + (var(--gutter-width) * 2));
                }
            }

            /* Large */
            @media screen and (min-width: 960px) and (max-width:1199px) {
                .col2{
                    display:block;
                }
                .col3{
                    display:block;
                    padding-right:calc(var(--col-width) + var(--gutter-width));
                }
                #np-compare-row > .label{
                    width: calc((var(--col-width) * 3) + (var(--gutter-width) * 2));
                }
            }
            /* XLarge and Up */
            @media screen and (min-width: 1200px) {
                .col2,
                .col3,
                .col4{
                    display:block;
                }
            }

            /*** Animation ***/
            :host(.scrollAnimate) #np-compare-row {
                animation-duration: 1s;
                animation-fill-mode: forwards;
            }

            :host(.scrollAnimate.animate) #np-compare-row {
                animation-name: contentInBottom;
            }

            /* Content sliding into view */
            @keyframes contentInBottom {
                0% {opacity:0; transform: translateY(30px);}
                100% {opacity:1; transform: translateY(0px);}
            }
            /*** END Animation ***/
        </style>

        <div id="np-compare-row">
            <div class="label"><slot></slot></div>
            <div class="col0"><slot name="col0"></slot></div>
            <div class="col1"><slot name="col1"></slot></div>
            <div class="col2"><slot name="col2"></slot></div>
            <div class="col3"><slot name="col3"></slot></div>
            <div class="col4"><slot name="col4"></slot></div>
        </div><!--END np-compare-row-->
    `;

    class NpCompareRow extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {
            /* Set default attribute value */
            if (!this.hasAttribute('jsonfield')) {
                this.setAttribute('jsonfield', "");
            }
        } /* END connectedCallback */

        static get observedAttributes() {
            return ['jsonfield'];
        }
      /* Getting attributes */
      get jsonfield() {
        return this.getAttribute('jsonfield');
      }

      /* Settinng attributes */
      set jsonfield(newValue) {
        this.setAttribute('jsonfield', newValue);
      }


    } /* END class */

    window.customElements.define('np-compare-row', NpCompareRow);

  })();
